var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "1600px",
    height: "1600px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 16000000 16000000",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".fil0 {fill:#DDE8E9}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_655851792"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M7999787 -59c-4418116,0 -7999799,3581943 -7999799,7999894 0,4417963 3581683,8000224 7999799,8000224 4418116,0 8000224,-3582049 8000224,-8000224 0,-4418164 -3582108,-7999894 -8000224,-7999894zm3803010 5757109l-759839 759851 -1546737 -1546631 -586772 586784 1546725 1546725 -3793726 3793419 -1546631 -1546465 -586772 586772 1546619 1546631 -378024 378024 -7205 -7193c-41917,69012 -110079,119350 -191043,137327l-1442304 321603c-21602,4854 -43571,7205 -65280,7205 -78721,0 -155197,-30992 -211890,-87839 -72756,-72484 -103039,-177177 -80646,-277500l321449 -1441879c18130,-80906 68587,-149221 137492,-191043l-7311 -7299 6105109 -6105381c89492,-89339 234886,-89339 324378,272l1222512 1222241c89504,89492 89504,234886 -106,324378z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPencil);
export default __webpack_public_path__ + "static/media/icon-pencil.4ad6cb75a61c8dc6b7b4924d5017a133.svg";
export { ForwardRef as ReactComponent };